import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';

import { ReportFilters } from './components';
import { useGetReportsQuery } from '../../api';
import type { Report } from '../../types';

export const Reports: FC = () => {
  const { t } = useTranslation();

  // api
  const { data: reports, isLoading: isReportsLoading } = useGetReportsQuery();

  // variables
  const isLoading = isReportsLoading;
  const [reportNameField, setReportNameField] = useState('');
  const [currentReport, setCurrentReport] = useState<Report | null>(null);

  // getting current report
  useEffect(() => {
    if (!reportNameField || !reports) return;

    const newCurrentReport =
      reports.reports.find((report) => report.name === reportNameField) ?? null;
    setCurrentReport(newCurrentReport);
  }, [reportNameField]);

  // elements
  const reportsOptions = reports?.reports
    ? reports.reports.map((report) => {
        return (
          <MenuItem key={report.name} value={report.name}>
            {report.title}
          </MenuItem>
        );
      })
    : [];

  return (
    <Grid size={{ xs: 12 }}>
      <Stack direction="column" spacing={2}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Stack direction="column" spacing={2} maxWidth={360}>
            <Typography variant="body1">{t('reports.label.choose-report')}</Typography>

            <TextField
              select
              name="report_type"
              value={reportNameField}
              onChange={(e) => setReportNameField(e.target.value)}
              label={t('reports.report-type')}
              fullWidth
            >
              {reportsOptions}
            </TextField>
          </Stack>
        </Paper>

        {currentReport && <ReportFilters report={currentReport} isReportsLoading={isLoading} />}
      </Stack>
    </Grid>
  );
};
